import { useEffect, useState } from 'react';
import _get from 'lodash/get';
import { NAV_DATA } from '../components/common/header/UnifiedNavV2';

const { PRIMARY } = NAV_DATA;

const usePDPActiveNavItems = (productData) => {
  const [activePrimaryNav, setActivePrimaryNav] = useState(PRIMARY.REGISTRY);
  const [activeSecondaryNavKey, setActiveSecondaryNavKey] = useState('');
  useEffect(() => {
    const topLevelCategory = _get(productData, 'category_chain[0].key');
    setActiveSecondaryNavKey(topLevelCategory);
    const isWeddingBoutique = _get(productData, 'wedding_shop_nav_details.secondary_nav_item_key');
    if (isWeddingBoutique) {
      setActivePrimaryNav(PRIMARY.WEDDING_BOUTIQUE);
    }
  }, [productData]);

  return {
    activePrimaryNav,
    activeSecondaryNavKey,
    isWeddingBoutiquePage: activePrimaryNav === PRIMARY.WEDDING_BOUTIQUE,
  };
};

export default usePDPActiveNavItems;
